import axios from "axios";
import { errorHandler } from "../exports/error_management";

import { StorageCache } from "../exports/dataStorage";
const storageKey = "ams-transaction-type-key";

const DEFAULT_ENTITY_IDX = 1;

const state = {
  item: null,
  items: [],
  options: {},
  entityIdx: DEFAULT_ENTITY_IDX,
};

const getters = {
  flowOptions(state) {
    const flows = (state.options || {}).flows || {};
    return (
      Object.keys(flows).map((key) => ({
        value: flows[key],
        text: key,
      })) || []
    );
  },
  entityOptions(state) {
    console.log("transactionType options", state.options);
    const entities = (state.options || {}).entities || {};
    return (
      Object.keys(entities).map((key) => ({
        value: entities[key],
        text: key,
      })) || []
    ).filter((x) => x.value !== -1);
  },

  referenceEntityOptions(state) {
    const entities = (state.options || {}).entities || {};
    return (
      Object.keys(entities).map((key) => ({
        value: entities[key],
        text: key === "Black Hole" ? "Loss Vault" : key,
      })) || []
    ).filter((x) => x.text !== "Officer");
  },
  flows(state) {
    return (state.options || {}).flows || {};
  },
  entities(state) {
    return (state.options || {}).entities || {};
  },
};

const mutations = {
  set_item(state, payload) {
    state.item = payload;
  },
  set_items(state, payload) {
    state.items = payload;
  },
  set_options(state, payload) {
    state.options = payload;
  },
  set_entity_index(state, idx) {
    if (isNaN(idx) || typeof idx === "undefined" || idx === null) {
      idx = DEFAULT_ENTITY_IDX;
    }
    state.entityIdx = idx;
  },
};

const actions = {
  async create({ dispatch }, payload) {
    try {
      new StorageCache(storageKey).reset();
      await axios.post(`transaction_type`, payload);
      dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchById({ commit }, id) {
    try {
      const {
        data: {
          success: { data },
        },
      } = await axios.get(`transaction_type/${id}`);
      console.log("fetch item", data);
      commit("set_item", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAll({ commit, dispatch }) {
    try {
      console.log("fetchall");
      await dispatch("fetchOptions");
      const storageCache = new StorageCache(storageKey);
      const { is_valid, value } = storageCache.getArray();
      if (!is_valid) {
        const {
          data: {
            success: { data },
          },
        } = await axios.get(`transaction_type`);
        console.log("fetchall", data);
        storageCache.set(data);
        value.splice(0);
        value.push(...data);
      }
      commit("set_items", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchOptions({ commit }) {
    try {
      const optionsKey = "ams-transaction-options-key";
      const storageCache = new StorageCache(optionsKey);
      const { is_valid, value } = storageCache.getObject();
      if (!is_valid) {
        const {
          data: {
            success: { data },
          },
        } = await axios.get(`transaction_type/options`);
        const _data = JSON.parse(data);
        storageCache.set(_data);
        Object.assign(value, _data);
      }
      commit("set_options", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async update({ dispatch }, payload) {
    console.log("update", payload);
    try {
      new StorageCache(storageKey).reset();
      await axios.put(`transaction_type/${payload.id}`, payload);
      dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async delete({ dispatch }, id) {
    try {
      new StorageCache(storageKey).reset();
      await axios.delete(`transaction_type/${id}`);
      dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
